import { render, staticRenderFns } from "./vc-select.vue?vue&type=template&id=1a0a5cce&scoped=true&"
import script from "./vc-select.vue?vue&type=script&lang=js&"
export * from "./vc-select.vue?vue&type=script&lang=js&"
import style0 from "./vc-select.vue?vue&type=style&index=0&id=1a0a5cce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a5cce",
  null
  
)

export default component.exports